import { AppSettings } from "@/AppSettings";
import { SourceDataFormStatus } from "@/api/dtos";

const sourceDataFormStatusToColor = (status?: SourceDataFormStatus) => {
    switch (status) {
        case SourceDataFormStatus.Complete:
            return 'success.main';
        case SourceDataFormStatus.Started:
            return 'warning.main';
        case SourceDataFormStatus.None:
        default:
            return 'error.main'
    }
}

export default sourceDataFormStatusToColor;